import { z } from "zod";
import type { Tables } from "../../types";
import type { ZodSatisfies } from "../types";

export const projectInvoiceSchema = z
	.object({
		calculatedTo: z.string().nullable(),
		number: z.string().min(1),
		progressInvoiceNumber: z.number().nullable(),
		note: z.string().nullable(),
		/**
		 * The date of the invoice.
		 * @example 2023-10-01
		 */
		creationDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
		projectId: z.string(),
		sum: z.number(),
		state: z.enum(["pending", "paid", "overdue"]),
		type: z.enum(["single-invoice", "progress-invoice", "final-invoice"]),
	} satisfies ZodSatisfies<Tables<"outgoingInvoices">>)
	.transform((data) => {
		if (data.type !== "progress-invoice") data.progressInvoiceNumber = null;
		return data;
	})
	.refine((data) => {
		if (data.type === "progress-invoice") return !!data.progressInvoiceNumber;
		return true;
	})
	.superRefine((data, ctx) => {
		if (data.type === "progress-invoice") {
			if (!data.calculatedTo)
				return ctx.addIssue({
					code: "custom",
					message: "Calculated to is required",
					path: ["calculatedTo"],
				});
		}
		if (data.type === "progress-invoice" && !data.progressInvoiceNumber) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Progress invoice number is required",
				path: ["progressInvoiceNumber"],
			});
		}
	});
export type ProjectInvoiceSchema = z.infer<typeof projectInvoiceSchema>;
